<template>
  <div>
    <Conversations />
  </div>
</template>

<script>
import { mapState } from "vuex";
import Conversations from '../common/Conversations.vue'

export default {
  components: {
    Conversations,
  },
  data () {
    return {
    }
  },
  computed: {
   
  },
}
</script>

<style lang="stylus">

</style>



// WEBPACK FOOTER //
// Conversations.vue